module.exports = __webpack_public_path__ + "img/background_intro.444c87cd.png";